import React, { useRef, useState } from "react";
import {
  Box,
  Button,
  Divider,
  Fab,
  FormControl,
  Grid,
  InputAdornment,
  InputLabel,
  MenuItem,
  Pagination,
  Select,
  Stack,
  Tab,
  Tabs,
  TextField,
  Typography,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";

import "react-datepicker/dist/react-datepicker.css";
import { useEffect } from "react";

import {
  getEmpearningSalary,
  getUnpaidUser,
  viewPaymentSlip,
} from "../paymentReceipt/paymentReceiptApi";

import { useSelector } from "react-redux";
import { Navigate, useNavigate } from "react-router";
import AddCourseModal from "./AddCourseModal";
import { getAllCourses, getInstitute } from "./instituteApi";

const Course = ({ clickEnquire }) => {
  const businessChooseTab = useSelector(
    (state) => state.reducer.businessChooseTab,
  );
  const [courses, setCourses] = useState();
  const [open, setOpen] = useState(false);
  const [modalData, setModalData] = useState(null);
  const [insid, setId] = useState();
  const userDetail = useSelector((state) => state.reducer.userDetail);
  let val = userDetail?.profileId?.split("?")[1];
  let billerId = Number(val?.split("=")[1]?.replace(/\D/g, ""));

  const getCourses = async () => {
    const payload = {
      billerId: billerId || userDetail?.userMasterId,
      filter: "",
      search: "",
    };

    // console.log("bbbb", billerId);

    getAllCourses(payload, (data) => {
      // console.log("Courses- ", data.data.data.list);
      setCourses(data.data.data.list);
    });
  };

  const getInstituteId = () => {
    getInstitute({ billerId: billerId || userDetail?.userMasterId }, (res) => {
      const obj = res?.data?.data?.list?.[0];

      setId(obj.id);

      console.log("iddd", insid);
    });
  };
  useEffect(() => {
    getCourses();
  }, []);
  useEffect(() => {
    getInstituteId();
  }, [open]);

  const tableGrid = {
    display: "grid",
    gridTemplateColumns: "140px 250px 200px 150px 200px 250px",
    alignItems: "center",
  };

const label = {
  fontSize: {
    xs: "12px",
    sm: "13px",
    md: "14px",
    lg: "15px",
  },
};

  const formatDate = (date) =>
    new Date(date)
      .toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      })
      .replace(/ /g, "-");

  return (
    <>
      {/* <DynamicBreadcrumbs /> */}
      <Box
        px={{ xs: 2, sm: 4 }}
        pb={4}
        container
        sx={{
          paddingTop: "15px",
          backgroundColor: "#E3E3FF",
          fontFamily: "'Montserrat', sans-serif",
        }}
      >
        <Grid container spacing={{ xs: 1, sm: 2 }}>
          <Grid
            item
            xs={12}
            sm={9}
            sx={{
              background:
                "linear-gradient(264deg, rgba(215, 215, 255, 0) 0%, rgba(155, 155, 243, 1) 100%)",
              padding: "10px",
              mt: "10px",
              borderRadius: "5px",
              color: "#01008B",
              textAlign: "left",
              marginBottom: "20px",
              fontFamily: "'Montserrat', sans-serif",
              fontSize: "20px",
              fontWeight: 500,
            }}
          >
            <Typography
              variant="h6"
              fontSize={{
                xs: "12px",
                sm: "13px",
                md: "16px",
              }}
              fontWeight="400"
            >
              Courses
            </Typography>
          </Grid>

          <Grid
            item
            // md={2}
            xs={12}
            sm={3}
            sx={{
              paddingRight: "0px",
            }}
          >
            <Button
              fullWidth
              onClick={() => {
                setModalData(null);
                setOpen(true);
              }}
              sx={{
                textTransform: "capitalize",
                width: {
                  xs: "100%",
                },
                fontSize: { xs: "12px", sm: "13px", md: "15px" },

                // p: "10px",
                whiteSpace: "nowrap",
              }}
              color="primary"
              variant="contained"
              aria-label="add"
            >
              Add Course Post
              <AddIcon sx={{ marginLeft: "6px" }} />
            </Button>
          </Grid>
        </Grid>

        <AddCourseModal
          getCourses={getCourses}
          modalData={modalData}
          setOpen={setOpen}
          open={open}
          id={insid}
        />

        <Box
          sx={{
            backgroundColor: "white",
            px: 2,
            py: 2,
            mt: 2,
            borderRadius: "12px",
            overflow: "auto",
            height: "75vh",
          }}
        >
          <Box sx={{ minWidth: "1280px" }}>
            {/* HEADER */}
            <Box
              sx={{
                ...tableGrid,
                borderBottom: "1.5px solid black",
                p: "10px",
                px: 6,
              }}
            >
              <Box sx={{ ...label, color: "#01008B", fontWeight: 500 }}>
                Course code
              </Box>

              <Box
                sx={{
                  ...label,
                  textAlign: "center",
                  color: "#01008B",
                  fontWeight: 500,
                }}
              >
                Course Name
              </Box>

              <Box
                sx={{
                  ...label,
                  textAlign: "center",
                  color: "#01008B",
                  fontWeight: 500,
                }}
              >
                Course Duration
              </Box>

              <Box
                sx={{
                  ...label,
                  textAlign: "left",
                  color: "#01008B",
                  fontWeight: 500,
                }}
              >
                Course Start Date
              </Box>

              <Box
                sx={{
                  ...label,
                  textAlign: "center",
                  color: "#01008B",
                  fontWeight: 500,
                }}
              >
                Course City
              </Box>
              <Box
                sx={{
                  ...label,
                  textAlign: "center",
                  color: "#01008B",
                  fontWeight: 500,
                }}
              ></Box>
              <Box />
            </Box>

            {/* DATA ROW */}
            {courses?.map((course, index) => {
              return (
                <Box
                  sx={{
                    ...tableGrid,
                    backgroundColor: "#E8E8FF",
                    borderRadius: "8px",
                    mt: 1,
                    mb: 1,
                    p: 1,
                    px: 6,

                    width: "fit-content",
                  }}
                >
                  <Box sx={{ ...label, px: 2, fontWeight: "medium" }}>
                    {course?.courseCode}
                  </Box>

                  <Box
                    sx={{ ...label, textAlign: "center", fontWeight: "medium" }}
                  >
                    {course?.courseName}
                  </Box>

                  <Box sx={{ ...label, textAlign: "center" }}>
                    {" "}
                    {course?.courseDuration}
                  </Box>

                  <Box sx={{ ...label, fontWeight: "medium" }}>
                    {" "}
                    {formatDate(course?.courseStartDate)}
                  </Box>

                  <Box
                    sx={{ ...label, textAlign: "center", fontWeight: "medium" }}
                  >
                    {course?.courseCity}
                  </Box>

                  <Box
                    sx={{
                      ...label,
                      display: "flex",
                      gap: 2,
                      alignItems: "center",
                    }}
                  >
                    <Button
                      onClick={() => {
                        setModalData(course);
                        setOpen(true);
                      }}
                      variant="contained"
                      sx={{ ...label, px: 8 }}
                    >
                      Edit
                    </Button>
                    <Button
                      onClick={() => {
                        clickEnquire(course);
                      }}
                      variant="outlined"
                      sx={{ ...label, px: 8 }}
                    >
                      Enquiries
                    </Button>
                  </Box>
                </Box>
              );
            })}
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default Course;
